var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"layout"}},[(_vm.renderPage)?_c('Header'):_vm._e(),_c('div',{staticClass:"contant"},[(_vm.renderPage)?_c('div',{staticClass:"screenWidth"},[_c('Breadcrumb'),_c('router-view')],1):_vm._e()]),(_vm.renderPage)?_c('Footer'):_vm._e(),(_vm.renderPage)?_c('VideoPlayer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }